import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    colors
} from '@mui/material';

/**
 * A reusable confirmation dialog.
 * @param {string} variant - The style variant ('confirm' or 'destructive'). Defaults to 'confirm'.
 */
const ActionConfirmation = ({
    open,
    onClose,
    onConfirm,
    title,
    msg,
    cancelText,
    confirmText,
    variant  ,
    icon
}) => {
    const isDestructive = variant === 'destructive';

    const confirmButtonSx = isDestructive ? {
        backgroundColor: '#FC003B',
        '&:hover': {
            backgroundColor: '#D00030'
        }
    } : {
        backgroundColor: '#69d945 !important',
        '&:hover': {
            backgroundColor: '#57b039'
        }
    };

    const iconRender = () => {
        let iconInfo = {};
        if (icon) {
            iconInfo = {
                name: icon ,
                colors: 'rgba(10, 10, 10, 0.33)'
            }
        }
        else {
            iconInfo = isDestructive ? {
                name: 'delete',
                color: '#FC003B'
            } : {
                name: 'check_circle',
                color: '#69d945'
            };

        }
        return (
            <span className="material-symbols-outlined" style={{ color: iconInfo.color }}>
                {iconInfo.name}
            </span>
        );
    };


    return (
        <Dialog open={open} onClose={onClose} PaperProps={{
            sx: {
                borderRadius: '16px',
            },
        }}>
            <DialogTitle>
                <div className="title-dialog">
                    <h2>
                   {iconRender()}
                        {title}
                    </h2>
                    <span className="material-symbols-outlined cursor-pointer" onClick={onClose}>
                        close
                    </span>
                </div>
            </DialogTitle>
            <DialogContent sx={{ mt: '24px', mb: '32px' }}>
                <Box display="flex" flexDirection="column" gap={2}>
                    <Typography>{msg}</Typography>
                </Box>
            </DialogContent>
            <DialogActions className='p0 actions-dialog'>
                <Button className='btn-actions-dialog-cancel' onClick={onClose}>
                    {cancelText}
                </Button>
                <Button
                    className='btn-actions-dialog-confirm'
                    onClick={onConfirm}
                    variant="contained"
                    sx={confirmButtonSx}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ActionConfirmation;